const getPrescriberPhone1 = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber.Phone) {
    return prescriber.Phone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(0, 3);
  }
  if (patient.Prescriber[0] && patient.Prescriber[0].Phone) {
    return patient.Prescriber[0].Phone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(0, 3);
  }
  return null;
};

export default getPrescriberPhone1;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberPhone1.js